import { Button } from '../../../Components/MUIs';
import Lottie from 'lottie-react';
import AiAnimation from '../../../Assets/animations/Success Check.json';
import { useAppNavigate } from '../../../Hooks/back/useAppNavigate';
import { useEffect } from 'react';
import { CommonActions } from '../../../Reducer/CommonReducer';
import { useDispatch } from 'react-redux';
import { useBackStack } from '../../../Hooks/back/useBackStack';

export default function Complete({ mode }) {
  const { navigate } = useAppNavigate();
  const dispatch = useDispatch();

  // 스택형 뒤로가기로 변경: 완료 화면에서는 허가서 목록으로 복귀
  useBackStack({
    type: 'navigate',
    onBack: () => navigate('/M_Permit'),
  });

  const BulletText = ({ text }) => (
    <p style={{ color: 'gray', position: 'relative', paddingLeft: '12px' }}>
      <span
        style={{
          position: 'absolute',
          left: '0',
          top: '50%',
          transform: 'translateY(-50%)',
        }}
      >
        •
      </span>
      {text}
    </p>
  );

  return (
    <div
      style={{
        display: 'flex',
        justifyContent: 'space-between',
        alignItems: 'center',
        flexDirection: 'column',
        textAlign: 'center',
        gap: '20px',
        height: '100%',
        overflow: 'hidden',
      }}
    >
      <div
        style={{
          display: 'flex',
          justifyContent: 'center',
          alignItems: 'center',
          flexDirection: 'column',
          textAlign: 'center',
          flex: 1,
          fontWeight: 'bold',
        }}
      >
        <Lottie
          animationData={AiAnimation}
          loop={false}
          autoplay
          style={{ width: '30%', backgroundColor: 'transparent' }}
        />
        {mode === 'signSm' ? (
          <p>작업허가서 승인이 완료됐어요.</p>
        ) : mode === 'signDep' ? (
          <p>
            작업허가서 서명이 완료되어 <br /> 관리자에게 승인 요청을 보냈어요.
          </p>
        ) : (
          <p>
            작업허가서 작성이 완료되어
            <br /> 관리자에게 승인 요청을 보냈어요.
          </p>
        )}
        {mode === 'signDep' || mode === 'signSm' ? (
          <BulletText text={'상세 내용은 목록에서 확인해주세요.'} />
        ) : (
          <>
            <BulletText text={'승인이 완료되면 알람을 보낼게요.'} />
            <BulletText text={'상세 내용은 목록에서 확인해주세요.'} />
          </>
        )}
      </div>
      <Button
        name="확인"
        sx={{
          width: '100%',
          height: 36,
          mt: 'auto',
          marginBottom: '16px',
          borderRadius: '5px',
          backgroundColor: '#57B84D',
          color: '#fff',
          boxShadow:
            ' 0px 2px 3px -1px rgba(0,0,0,0.1), 0px 1px 0px 0px rgba(25,28,33,0.02), 0px 0px 0px 1px rgba(25,28,33,0.08)',
        }}
        onClick={() => {
          dispatch(CommonActions.setActiveStep(0));
          navigate('/M_Permit'); //작업허가서 목록
        }}
      />
    </div>
  );
}
